import { CheckCircleLinear, ClockCircleLinear, FolderLinear } from "solar-icon-set";
import { clientEnv } from "@/lib/env.client";

// Gives the visitor a moment to read where they are being sent before Trimble takes over.
export const PUBLIC_TRIAL_REDIRECT_DELAY_MS = 3000;

export const PUBLIC_TRIAL_DETAILS = [
  { label: "duration", Icon: ClockCircleLinear },
  { label: "projects", Icon: FolderLinear },
  { label: "access", Icon: CheckCircleLinear },
] as const;

export const TURNSTILE_TEST_SITE_KEY = "1x00000000000000000000AA";

export const TURNSTILE_SITE_KEY = clientEnv().NEXT_PUBLIC_TURNSTILE_SITE_KEY;
